module.exports = __webpack_public_path__ + "media/images/obamacare-ea1de48218ad84f51752450498dd6edb.png";